module.exports = __webpack_public_path__ + "media/images/sec_3-9-a914551b9144efdf51d90a72a200744d.png";